import { toSentenceCase } from '@noths/polaris-client-utils';

export interface ResolveTaxonomyHeading {
  /** The matched Contentstack entry's heading, when content exists for the page. */
  heading?: string;
  /**
   * The lowest active taxonomy level's label (e.g. "earrings"). Absent at the
   * surface root, where no taxonomy level is active.
   */
  taxonomyLabel?: string;
}

/**
 * Single source of truth for the shop PLP heading shown in the h1, the HTML
 * `<title>` and the current-page breadcrumb. The matched Contentstack entry's
 * authored heading is used verbatim; the taxonomy fallback is a raw level value
 * from a casing-agnostic selector, so it is sentence-cased here at the point of
 * display. Returns `undefined` when neither is available (e.g. the surface root).
 */
export const resolveTaxonomyHeading = ({
  heading,
  taxonomyLabel,
}: ResolveTaxonomyHeading): string | undefined =>
  heading || (taxonomyLabel ? toSentenceCase(taxonomyLabel) : undefined);
